/**
 * Wires a debounced "input" listener to a search box. The handler fires
 * after the user pauses typing for `debounceMs`, with the trimmed value.
 */
export function attachSearch(
  input: HTMLInputElement,
  onChange: (query: string) => void,
  debounceMs = 300,
): void {
  let timer: number | undefined;
  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => onChange(input.value.trim()), debounceMs);
  });
}
